import { Component, Input, OnInit } from '@angular/core';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Schedule } from 'src/app/shared/models/schedule.model';
import { TrainingSessionsService } from '../training-sessions.service';

@Component({
    selector: 'app-training-session-schedule-item',
    templateUrl: './training-session-schedule-item.component.html',
    styleUrls: ['./training-session-schedule-item.component.css'],
    standalone: false
})
export class TrainingSessionScheduleItemComponent implements OnInit {

  @Input() elementIndex: number;
  @Input() schedule: Schedule;

  public icons: { [name: string]: any } = {
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt,
  };

  constructor(private _trainingSessionsService: TrainingSessionsService) {
  }

  ngOnInit(): void {
    if (!this.schedule) {
      this.schedule = this._trainingSessionsService.schedules[this.elementIndex];
    }
  }

  public onEditClick() {
    this._trainingSessionsService.onScheduleEdit.next(this.elementIndex);
  }

  public onDeleteClick() {
    this._trainingSessionsService.onScheduleDelete.next(this.elementIndex);
  }
}
